<template>
    <div>
        <!-- <vue2-org-tree
            :data="data"
        :horizontal="true"
            :label-class-name="labelClassName"
            collapsable
            @on-expand="onExpand"
            @on-node-click="NodeClick"
            @on-node-mouseover="onMouseover"
            @on-node-mouseout="onMouseout"
            :renderContent="renderContent"
        /> -->
        <vue2-org-tree
            :data="data"
            :label-class-name="labelClassName"
            collapsable
            @on-expand="onExpand"
            @on-node-click="NodeClick"
            @on-node-mouseover="onMouseover"
            @on-node-mouseout="onMouseout"
            :renderContent="renderContent"
        />
    </div>
</template>

<script>
export default {
    props: ["data"],
    data() {
        return {
            labelClassName: "bg-color-orange",
            basicInfo: { id: null, label: null },
            basicSwitch: false
        };
    },
    mounted() {},
    methods: {
        //渲染节点
        renderContent(h, data) {
            return data;
        },
        //鼠标移出
        onMouseout(e, data) {
            this.basicSwitch = false;
        },
        //鼠标移入
        onMouseover(e, data) {
            //   this.basicInfo = data;
            //   this.basicSwitch = true;
            //   var floating = document.getElementsByClassName("floating")[0];
            //   floating.style.left = e.clientX + "px";
            //   floating.style.top = e.clientY + "px";
        },
        //点击节点
        NodeClick(e, data) {
            this.$emit("NodeClick", e, data);
        },
        //默认展开
        toggleExpand(data, val) {
            if (Array.isArray(data)) {
                data.forEach((item) => {
                    this.$set(item, "expand", val);
                    if (item.children) {
                        this.toggleExpand(item.children, val);
                    }
                });
            } else {
                this.$set(data, "expand", val);
                if (data.children) {
                    this.toggleExpand(data.children, val);
                }
            }
        },
        collapse(list) {
            list.forEach((child) => {
                if (child.expand) {
                    child.expand = false;
                }
                child.children && this.collapse(child.children);
            });
        },
        //展开
        onExpand(e, data) {
            if ("expand" in data) {
                data.expand = !data.expand;
                if (!data.expand && data.children) {
                    this.collapse(data.children);
                }
            } else {
                this.$set(data, "expand", true);
            }
        }
    },
    watch: {
        data: function(newVal, oldVal) {
            this.toggleExpand(this.data, true);
        }
    }
};
</script>

<style lang="less" scoped>
.org-tree-node-label-inner {
    color: #fff;
    background-color: orange;
}
</style>



// WEBPACK FOOTER //
// src/components/orgtree.vue